import { render, staticRenderFns } from "./platForm.vue?vue&type=template&id=0c655201&scoped=true"
import script from "./platForm.vue?vue&type=script&lang=js"
export * from "./platForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c655201",
  null
  
)

export default component.exports